import { render, staticRenderFns } from "./ProductAddToCart.vue?vue&type=template&id=9a5f0610&"
import script from "./ProductAddToCart.vue?vue&type=script&lang=js&"
export * from "./ProductAddToCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports